module.exports = __webpack_public_path__ + "img/available_in_hours.cb83ee39.svg";